/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ early_bird_discount_percent: NonNullable<unknown> }} Subscription_Discount_PromotionInputs */

const en_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Early Bird Offer ${i?.early_bird_discount_percent}% OFF!`)
};

const ar_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عرض الحجز المبكر ${i?.early_bird_discount_percent}% خصم!`)
};

const de_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frühbucherangebot ${i?.early_bird_discount_percent}% OFF!`)
};

const es_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferta por reserva anticipada ¡${i?.early_bird_discount_percent}% de descuento!`)
};

const fr_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offre premiers arrivés -${i?.early_bird_discount_percent}%!`)
};

const it_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offerta Early Bird ${i?.early_bird_discount_percent}% DI SCONTO!`)
};

const ja_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`早期割引オファー ${i?.early_bird_discount_percent}%OFF！`)
};

const ko_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`얼리버드 혜택 ${i?.early_bird_discount_percent}% 할인!`)
};

const pt_br_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferta antecipada com ${i?.early_bird_discount_percent}% OFF!`)
};

const ru_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предложение для ранних пташек: ${i?.early_bird_discount_percent}% скидка!`)
};

const th_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอก่อนเวลา ลด ${i?.early_bird_discount_percent}%!`)
};

const tr_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erkenci Fırsatı % ${i?.early_bird_discount_percent} İNDİRİM!`)
};

const zh_cn_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`早鸟优惠方案 ${i?.early_bird_discount_percent}% OFF！`)
};

const zh_tw_subscription_discount_promotion = /** @type {(inputs: Subscription_Discount_PromotionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`早鳥優惠方案 ${i?.early_bird_discount_percent}% OFF！`)
};

/**
* | output |
* | --- |
* | "Early Bird Offer {early_bird_discount_percent}% OFF!" |
*
* @param {Subscription_Discount_PromotionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_discount_promotion = /** @type {((inputs: Subscription_Discount_PromotionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Discount_PromotionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_discount_promotion(inputs)
	if (locale === "ar") return ar_subscription_discount_promotion(inputs)
	if (locale === "de") return de_subscription_discount_promotion(inputs)
	if (locale === "es") return es_subscription_discount_promotion(inputs)
	if (locale === "fr") return fr_subscription_discount_promotion(inputs)
	if (locale === "it") return it_subscription_discount_promotion(inputs)
	if (locale === "ja") return ja_subscription_discount_promotion(inputs)
	if (locale === "ko") return ko_subscription_discount_promotion(inputs)
	if (locale === "pt_br") return pt_br_subscription_discount_promotion(inputs)
	if (locale === "ru") return ru_subscription_discount_promotion(inputs)
	if (locale === "th") return th_subscription_discount_promotion(inputs)
	if (locale === "tr") return tr_subscription_discount_promotion(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_discount_promotion(inputs)
	return zh_tw_subscription_discount_promotion(inputs)
});